export const SERVICE_RENDERED_OPTIONS = [
	{
		label: 'ORIGIN',
		name: 'serviceRendered',
		value: 1,
		isDisabled: false
	},
	{
		label: 'DESTINATION',
		name: 'serviceRendered',
		value: 2,
		isDisabled: false
	},
	{
		label: 'FREIGHT',
		name: 'serviceRendered',
		value: 3,
		isDisabled: false
	},
];
